module.exports = __webpack_public_path__ + "img/smart_carousel_1.4df72822.png";